module.exports = __webpack_public_path__ + "438f8698ebd2a7bd7c3ec34748eae82b.png";